import React, { PropsWithChildren } from "react";

import { useBoxStyle } from "./AHTheme/useBoxStyle";
import { View } from "react-native";
import { ColorType } from "./AHTheme/AHTheme";

export type CardProps = PropsWithChildren<{
  noSpace?: boolean;
  color?: ColorType;
  defaultBorder?: boolean;
  row?: boolean;
}>;

export function Card(props: CardProps) {
  const style = useCardStyle(props);
  return (
    <View
      style={[
        style,
        {
          overflow: "hidden",
          borderWidth: props?.defaultBorder ? 1 : 0,
          flexDirection: props.row ? "row" : undefined,
        },
      ]}
    >
      {props.children}
    </View>
  );
}

export function useCardStyle(props?: CardProps) {
  return useBoxStyle({
    color: props?.color ?? ("surface-primary" as const),
    cornerRadius: "large",
    space: props?.noSpace ? "none" : "medium",

    borderColor: "border-primary",
  });
}
